<template>
  <div class="container">
    <h1>お楽しみいただくために</h1>
    <div class="notice-list-wrapper">
      <ul class="notice-list">
        <li>スマートフォンをご利用の場合は画面を横にしてください。</li>
        <li>本コンテンツは音声が流れます。</li>
      </ul>
    </div>
    <div class="next-button" @click="moveToTitle">次へ</div>
  </div>
</template>

<script>
  export default {
    name: "Welcome",
    methods: {
      moveToTitle() {
        this.$router.push("/title");
      }
    },
    mounted() {
      this.$emit("stop");
    }
  }
</script>

<style scoped>

  .container {
    background: url("../assets/img/welcome_bg.png") no-repeat fixed center;
    background-size: contain;
    padding-top: 10%;
  }

  .container h1 {
    text-align: center;
  }

  .notice-list-wrapper {
    margin: 5vh auto;
    width: 50%;
  }

  .notice-list {
    font-weight: bold;
    line-height: 2;
  }

  .next-button {
    margin: 0 auto;
    padding: 8px 16px;
    text-align: center;
    font-weight: bold;
    color: #FFFFFF;
    border-radius: 8px;
    background-color: #898989;
    width: 128px;
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {

    .container {
      padding-top: 2vw;
    }

    .notice-list-wrapper {
      margin: 3vw auto;
      width: 90%;
    }

  }

</style>